import { render, staticRenderFns } from "./BenefitsDetail.vue?vue&type=template&id=cf1e262e&scoped=true&lang=html&"
import script from "./BenefitsDetail.vue?vue&type=script&lang=js&"
export * from "./BenefitsDetail.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsDetail.vue?vue&type=style&index=0&id=cf1e262e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1e262e",
  null
  
)

export default component.exports